import React from "react";
import { FiTrash2 } from "react-icons/fi";
import "./SmartTile.css";

export default function SmartTile({
  icon = "??",
  title,
  subtitle,
  rightSlot,
  onClick,
  onDelete,
  deleteLabel = "Delete",
  ariaLabel,
  iconSize = "22px",
  className = "",
  style = {},
}) {
  const handleKey = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onClick?.();
    }
  };

  return (
    <div
      className={`smart-tile ${className}`}
      style={style}
      role="button"
      tabIndex={0}
      aria-label={ariaLabel || title}
      onClick={onClick}
      onKeyDown={handleKey}
    >
      <div className="smart-left">
        <span
          className="smart-icon"
          aria-hidden="true"
          style={{ fontSize: iconSize }}
        >
          {icon}
        </span>
        <div className="smart-text">
          <div className="smart-title" title={title}>
            {title}
          </div>
          {subtitle && <div className="smart-sub">{subtitle}</div>}
        </div>
      </div>

      <div className="smart-right">
        {rightSlot}
        {onDelete && (
          <button
            type="button"
            className="smart-danger"
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
            title={deleteLabel}
            aria-label={deleteLabel}
          >
            <FiTrash2 />
          </button>
        )}
      </div>
    </div>
  );
}
